import { render, staticRenderFns } from "./leyenda.html?vue&type=template&id=516a90b7&"
import script from "./leyenda.ts?vue&type=script&lang=ts&"
export * from "./leyenda.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports